import { AxiosResponse } from 'axios'
import { localConfig } from '../../Configs/localConfig'
import { api } from '../api'
import { destroyAlert, errorAlert, successAlert } from '../../utils/alert'

interface Props {
  embed?: string
  codConta?: number
  codCliente?: number
  page?: number
  limit?: number
  pagination?: number
}

const url = '/change-log-info'

export const getLogs = async (params: Props) => {
  const { acesso, conta, codCliente } = localConfig()
  api.defaults.headers.Acesso = acesso

  const response = await api.get(url, {
    params: {
      codConta: conta,
      codCliente: codCliente,
      ...params,
    },
  })

  return response
}

export const postLogs = async (
  data,
  setTitulo,
  setDescricao,
  setTipoLog,
  setBranch,
  setSubLogs,
  setNovoSubLogDesc,
  setNovoSubLogTipo,
  setNovoSubLogTipoID,
  setNovoSubLogPrivado,
  setUsuario,
  setUsuarioID
) => {
  const { titulo, descricao, aplicacao, tipo, branch, logs, cod_usuario, version } = data

  api.defaults.headers.Acesso = 'admin'

  const response: AxiosResponse = await api
    .post('/change-log', {
      titulo: titulo,
      descricao: descricao,
      aplicacao: aplicacao,
      tipo: tipo,
      branch: branch,
      logs: logs,
      cod_usuario: cod_usuario,
      versao: version
    })
    .then((): any => {
      destroyAlert();
      successAlert('ChangeLog cadastrado com sucesso!');
      setTitulo('');
      setDescricao('');
      setTipoLog('');
      setBranch('');
      setSubLogs([]);
      setNovoSubLogDesc('');
      setNovoSubLogTipo('');
      setNovoSubLogTipoID(0);
      setNovoSubLogPrivado(false);
      setUsuario('');
      setUsuarioID(0);
    })
    .catch(() => {
      destroyAlert();
      errorAlert('Falha ao cadastrar changeLog');
    })

  return response
}

export const putLogs = async (
  data,
  cod,
  setTitulo,
  setDescricao,
  setTipoLog,
  setBranch,
  setSubLogs,
  setNovoSubLogDesc,
  setNovoSubLogTipo,
  setNovoSubLogTipoID,
  setNovoSubLogPrivado,
  setUsuario,
  setUsuarioID
) => {
  const { titulo, descricao, aplicacao, tipo, branch, logs, cod_usuario, logs_remover, versao } = data

  api.defaults.headers.Acesso = 'admin'

  const response: AxiosResponse = await api
    .put(`/change-log/${cod}`, {
      titulo: titulo,
      descricao: descricao,
      aplicacao: aplicacao,
      tipo: tipo,
      branch: branch,
      logs: logs,
      cod_usuario: cod_usuario,
      versao: versao,
      logs_remover: logs_remover
    })
    .then((): any => {
      destroyAlert();
      successAlert('ChangeLog atualizado com sucesso!');
      setTitulo('');
      setDescricao('');
      setTipoLog('');
      setBranch('');
      setSubLogs([]);
      setNovoSubLogDesc('');
      setNovoSubLogTipo('');
      setNovoSubLogTipoID(0);
      setNovoSubLogPrivado(false);
      setUsuario('');
      setUsuarioID(0);
    })
    .catch(() => {
      destroyAlert();
      errorAlert('Falha ao atualizar changeLog');
    })

  return response
}

export const deleteLog = async (cod) => {
  const { acesso, conta, codCliente } = localConfig()
  api.defaults.headers.Acesso = 'admin'

  const response = await api.delete(
    `/change-log/${cod}?codConta=${conta}&codCliente=${codCliente}`)

    .then((): any => {
      destroyAlert();
      successAlert('ChangeLog deletado com sucesso!');
     
    })
    .catch(() => {
      destroyAlert();
      errorAlert('Falha ao deletar changeLog');
    })

  return response
}

export const getUsuarioLog = async () => {
  const config = localConfig()

  api.defaults.headers.Acesso = 'admin'

  const response: AxiosResponse = await api.get('/change-log/usuarios')

  return response
}
